import { render } from "./ComponenteSOS.vue?vue&type=template&id=8a3febf8&scoped=true"
import script from "./ComponenteSOS.vue?vue&type=script&lang=js"
export * from "./ComponenteSOS.vue?vue&type=script&lang=js"

import "./ComponenteSOS.vue?vue&type=style&index=0&id=8a3febf8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\sisco\\Documents\\logistica\\AppChoferes\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a3febf8"]])

export default __exports__